import React from "react";

const ITEMS = [
  "BUY",
  "SELL",
  "TRADE",
  "SEALED",
  "SLABS",
  "SINGLES",
  "POKÉMON TCG",
  "SPRINGTOWN · TX",
  "APPOINTMENT ONLY",
];

const Bullet = () => (
  <span className="inline-block w-3 h-3 bg-black rotate-45 mx-6 align-middle" aria-hidden="true" />
);

export default function Marquee() {
  const sequence = [...ITEMS, ...ITEMS]; // duplicate for seamless loop
  return (
    <div
      data-testid="hero-marquee"
      className="bg-[#FF1F1F] text-white border-y-4 border-black overflow-hidden py-4 select-none"
      aria-label="Rocket Card Shop services marquee"
    >
      <div className="marquee-track font-heading text-3xl sm:text-4xl uppercase tracking-wider">
        {sequence.map((label, i) => (
          <span key={`${label}-${i}`} className="inline-flex items-center">
            {label}
            <Bullet />
          </span>
        ))}
      </div>
    </div>
  );
}
